var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.557,
    height: 17.003,
    viewBox: "0 0 22.557 17.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23278",
    "data-name": "Group 23278",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13849",
    "data-name": "Path 13849",
    d: "M1090.5-2164.314l7.363-7.468,2.663,2.742s.339.365.94-.131,2.454-2.48,2.454-2.48l7.442,7.337Z",
    transform: "translate(-1089.558 2181.317)",
    fill: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M7.519,0l7.519,7.519H0Z",
    transform: "translate(15.038 16.291) rotate(-90)",
    fill: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M7.519,0l7.519,7.519H0Z",
    transform: "translate(7.519 1.253) rotate(90)",
    fill: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_4",
    "data-name": "Polygon 4",
    d: "M10.652,0,21.3,10.652H0Z",
    transform: "translate(21.931 10.652) rotate(180)",
    fill: "#9d9d9d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.e333f2ab16584e22380b0088c5a1d699.svg";
export { ForwardRef as ReactComponent };